const consts = {};

/**
 * Account profile.
 */
consts.PROFILE = {
    DEFAULT: 1,
    ADMIN: 9,
};

module.exports = consts;
